module.exports = __webpack_public_path__ + "img/tu_schedule_training_active.e5049d85.svg";